import { render, staticRenderFns } from "./xjyhpopup.vue?vue&type=template&id=2d38bb18&scoped=true&"
import script from "./xjyhpopup.vue?vue&type=script&lang=js&"
export * from "./xjyhpopup.vue?vue&type=script&lang=js&"
import style0 from "./xjyhpopup.vue?vue&type=style&index=0&id=2d38bb18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d38bb18",
  null
  
)

export default component.exports